import { includes } from 'lodash-es';
import constants from '../constants.js';

export function getLoadedStatus(statuses) {
  return includes(statuses, constants.FAILED_FATAL)
    ? constants.FAILED_FATAL
    : includes(statuses, constants.FAILED)
    ? constants.FAILED
    : includes(statuses, constants.FAILED_NOT_FOUND)
    ? constants.FAILED_NOT_FOUND
    : includes(statuses, constants.UNLOADED)
    ? constants.UNLOADED
    : constants.LOADED;
}
